export default "__VITE_ASSET__DkEMbas9__"